import {
  FILE_UPLOAD_ACTIONS,
  NFTS_PROFILE_ACTIONS
} from '../../../constants/actions'
import { mergeToNewObject } from '../../../util/object.helpers'
import {
  DEFAULT_CONTAINER_STATE,
  NFTS_PROCESS_STEP
} from '../../../constants/containerStates'
import { NFT_ERRORS } from '../../../constants/apiErrors'

export const nftsProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case NFTS_PROFILE_ACTIONS.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case NFTS_PROFILE_ACTIONS.ON_CREATE_NFT:
      return mergeToNewObject(state, {
        isProcessing: true
      })

    case NFTS_PROFILE_ACTIONS.ON_CREATE_NFT_SUCCESS:
      return mergeToNewObject(state, {
        ...INITIAL_STATE,
        nftPopupState: NFTS_PROCESS_STEP.NFT_CREATED,
        isProcessing: false
      })

    case NFTS_PROFILE_ACTIONS.ON_CREATE_NFT_FAILED:
      return mergeToNewObject(state, {
        isProcessing: false
      })

    case FILE_UPLOAD_ACTIONS.ON_GET_PRESIGNED_URL_FAILED:
      return mergeToNewObject(state, handleCreateNftErrors(payload.response), {
        isProcessing: false
      })

    case NFTS_PROFILE_ACTIONS.ON_TRANSFER_NFT:
      return mergeToNewObject(state, {
        nftPopupState: DEFAULT_CONTAINER_STATE.NONE,
        transferId: '',
        error: ''
      })

    case NFTS_PROFILE_ACTIONS.ON_TRANSFER_NFT_SUCCESS:
      return mergeToNewObject(state, {
        nftPopupState: NFTS_PROCESS_STEP.NFT_TRANSFERRED
      })

    case NFTS_PROFILE_ACTIONS.ON_TRANSFER_NFT_FAILED:
      return mergeToNewObject(state, {
        nftPopupState: DEFAULT_CONTAINER_STATE.SOMETHING_WENT_WRONG
      })

    case NFTS_PROFILE_ACTIONS.RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  error: '',
  success: '',
  isProcessing: false,

  media: '',
  name: '',
  type: '',
  externalLink: '',
  description: '',
  exclusiveContent: '',
  pointValue: '',
  supply: '',
  showNft: '',
  userSale: '',
  userTransfer: '',
  userSalesFee: '',

  transferId: '',

  nftPopupState: DEFAULT_CONTAINER_STATE.NONE
}

export const NFTS_PROFILE_DISPATCH = {
  ERROR: 'error',
  SUCCESS: 'success',
  MEDIA: 'media',
  NAME: 'name',
  TYPE: 'type',
  EXTERNAL_LINK: 'externalLink',
  DESCRIPTION: 'description',
  EXCLUSIVE_CONTENT: 'exclusiveContent',
  POINT_VALUE: 'pointValue',
  SUPPLY: 'supply',
  NFT_POP_UP_STATE: 'nftPopupState',
  SHOW_NFT: 'showNft',
  USER_SALE: 'userSale',
  USER_TRANSFER: 'userTransfer',
  USER_SALES_FEE: 'userSalesFee',
  TRANSFER_ID: 'transferId'
}

const handleCreateNftErrors = ({ errors }) => {
  switch (errors.detail) {
    case NFT_ERRORS.FILE_TYPE_NOT_SUPPORTED:
      return {
        nftPopupState: NFTS_PROCESS_STEP.FILE_TYPE_NOT_SUPPORTED
      }
    default:
      return {
        nftPopupState: DEFAULT_CONTAINER_STATE.NONE
      }
  }
}
